import axios from 'axios'
import router from '@/router'

export default function () {

    // This function is used for android webview (USE axios http only)
    function hasNotIntercept(path) {
        if ( // Path to avoid intercept
            path.indexOf("/posttest") > -1 ||
            path.indexOf("/pretest") > -1 ||
            path.indexOf("/quiz") > -1 ||
            path.indexOf("/quizzes") > -1
        ) {
            return true;
        }

        return false;
    }

    axios.interceptors.request.use(function (config) {
        let token = localStorage.getItem('accessToken'); // uses local storage directly
        if (token) {
            if (!hasNotIntercept(config.url)) {
                config.headers.Authorization = `Bearer ${token}`;
            }
        }
        return config;

    }, function (err) {
        return Promise.reject(err);
    });

    axios.interceptors.response.use(function (response) {
        return response;

    }, function (error) {

        if (!hasNotIntercept(error.config.url)) {

            if (error.response.status === 401) {
                sessionStorage.clear()
                localStorage.clear()
                localStorage.removeItem("accessUsername");
                localStorage.removeItem("userRole");
                localStorage.removeItem("accessToken");
                localStorage.removeItem("accessUserId");
                router.push('/pages/login');

            } else if (error.response.status === 403) {
                router.push('/pages/not-authorized');
                // router.push('/dashboard/appenglish');

            } else if (error.response.status === 404) {
                // router.push('/pages/error-404');

            }
        }

        return Promise.reject(error)
    });

    $.ajaxSetup({
        beforeSend: function (xhr) {
            let token = localStorage.getItem('accessToken'); // uses local storage directly
            if (token) {
                xhr.setRequestHeader('Authorization', `Bearer ${token}`);
            }
        },
        statusCode: {
            401: function () {
                localStorage.removeItem("accessUsername");
                localStorage.removeItem("userRole");
                localStorage.removeItem("accessToken");
                localStorage.removeItem("accessUserId");
                router.push('/pages/login');
            },
            403: function () {
                // router.push('/pages/not-authorized');
                // router.push('/dashboard/appenglish');
            },
            404: function () {
                // router.push('/pages/error-404');
            }
        }
    });


}
